// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.height-1rem[data-v-23543608] {\n  line-height: 1rem !important;\n}\n.case-title[data-v-23543608] {\n  line-height: 1.5rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
